module.exports = __webpack_public_path__ + "img/style_swiper_01.205b28a7.png";